var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('CartView'),_c('keep-alive',[(_vm.isRouterAlive)?_c('router-view',{staticClass:"view"}):_vm._e()],1),(!_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('ClientHeight'),_c('PopupAd')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }